'use strict';

var util = require('../../util/property-util');
var nocUtil = require('../../util/noc-util');
var graphUtil = require('../../util/graph-util');

module.exports = /*@ngInject*/ ["$filter", function ($filter) {
    var factory = {};
    var previousInfoWindow;

    factory.createTimestampMap = function (array, property, createSeriesObjectFunction) {
        if (!util.isDefined(createSeriesObjectFunction)) {
            createSeriesObjectFunction = function (property, object) {
                return object;
            }
        }

        var map = new Map();
        array.forEach(function (entry) {
            map.set(entry.timestamp, createSeriesObjectFunction(property, entry));
        });
        return map;
    };

    factory.mergeDataMaps = function (gpsMap, dataMap) {
        var array = [];

        gpsMap.forEach(function (value, key) {
            var found = dataMap.get(key);
            var obj = angular.extend({}, found, value);
            array.push(obj);
        });
        return array;
    };

    factory.interpolatDataMaps = function (gpsMap, dataMap, interval, previousData) {
        "use strict";
        var array = [];

        gpsMap.forEach(function (value, key) {
            var found = dataMap.get(key);
            if (!util.isDefined(found)) {
                var tmpKey = key - 1000;
                do {
                    found = dataMap.get(tmpKey);
                    tmpKey -= 1000;
                    if (key - (interval * 1000) > tmpKey) {
                        break;
                    }
                } while (!util.isDefined(found));
            }

            if(!util.isDefined(found) && util.isDefined(previousData)) {
                if(previousData.timestamp >= key - (interval * 1000)){
                    found = {
                        timestamp: new Date(key),
                        value: previousData.value
                    }
                }
            }
            var obj = angular.extend({}, found, value);
            array.push(obj);
        });
        return array;
    };

    factory.getLastMatchedTimestamp = function (data) {
        for (var i = data.length - 1; i >= 0; i--) {
            var entry = data[i];
            if (util.isDefined(entry.value) && entry.value != -1) {
                return entry.timestamp;
            }
        }
    };

    factory.plotData = function (googleMap, filter, data, colors, valueFormatFunction) {
        var processNullValues = function (data) {
            data.forEach(function (entry) {
                if (!util.isDefined(entry.value)) {
                    entry.value = -1;
                }
            });
        };
        // data entries with "null" values get value -1
        processNullValues(data);
        var foundBoundaries = findMinMaxInData(data);
        // create and add polylines to the map
        var polylines = createCoverageMap(googleMap, data, colors, filter, valueFormatFunction);
        return {polylines: polylines, foundBoundaries: foundBoundaries};
    };

    factory.addDataToMap = function (map, data, filter, colors, valueFormatFunction) {
        var polylines = createCoverageMap(map, data, colors, filter, valueFormatFunction);
        return {polylines: polylines, foundBoundaries: undefined};
    };

    /**
     * Zooms map to fit all datapoints on it
     * @param data  array of objects with latitude & longitude properties
     * @param map   the google maps object
     */
    factory.fitDataPointsOnMap = function (data, map) {
        var arr = [];
        for (var i = 0; i < data.length; ++i) {
            var entry = data[i];
            if (util.isDefined(entry) && util.isDefined(entry.latitude) && util.isDefined(entry.longitude) && entry.latitude != 0 && entry.longitude != 0) {
                var wp = new google.maps.LatLng(entry.latitude, entry.longitude);
                arr.push(wp);
            }
        }
        var bounds = getOuterBounds(arr, map);
        if (map) {
            map.fitBounds(bounds);
        } else {
            console.error("map is undefined");
        }
    };

    factory.generateColors = function (min, max, variations, reverseColors, logscale) {
        if (max == min) {
            return [{
                value: max,
                color: nocUtil.generateColorByValue(max, min, max, reverseColors),
                min: min,
                max: max
            }]
        }

        if (logscale) {
            return getLogaritmicColorDistribution(min, max, variations, reverseColors);
        } else {
            return getLineairColorDistribution(min, max, variations, reverseColors);
        }

    };
    var getLogaritmicColorDistribution = function (min, max, variations, reverseColors) {
        var getDelta = function (min, max, n) {
            return Math.log10(max / min) / n;
        };

        var delta = getDelta(min, max, variations);
        var colors = [];
        for (var i = 0; i < variations; i++) {
            var colorEntry = {
                color: nocUtil.generateColorByValue(i, 0, variations, reverseColors),
                min: Math.floor((Math.pow(10, i * delta + Math.log10(min))) * 100) / 100,
                max: Math.ceil((Math.pow(10, (i + 1) * delta + Math.log10(min))) * 100) / 100
            };
            colors.push(colorEntry);
        }

        return colors;
    };
    var getLineairColorDistribution = function (min, max, variations, reverseColors) {
        var interval = (max - min) / variations;

        var colors = [];

        for (var i = 0; i < variations; i++) {
            var value = min + (interval * i) + (interval / 2);
            // interval: [min+Δ*n;min+Δ*(n+1)[
            var colorEntry = {
                min: min + interval * i,
                max: min + interval * (i + 1),
                color: nocUtil.generateColorByValue(value, min, max, reverseColors, false),
                value: value
            };
            colors.push(colorEntry);
        }
        return colors;
    };

    factory.generateLegendItems = function (colorArray, formatFunction, unit) {
        var legend = [];
        colorArray.forEach(function (colorEntry) {
            var entry = {
                'background-color': colorEntry.color,
                value: formatFunction(colorEntry.max, unit),
                min: formatFunction(colorEntry.min, unit),
                max: formatFunction(colorEntry.max, unit)
            };
            legend.push(entry);
        });
        return legend;
    };

    factory.generateStaticLegendItems = function (data, formatFunction) {
        var map = new Map();
        data.forEach(function (entry) {
            if (entry.value != -1) {
                map.set(entry.value, getSemiRandomColorFromArray(entry.value));
            }
        });

        var legendArray = [];
        map.forEach(function (color, key) {
            legendArray.push({
                'background-color': color,
                value: formatFunction(key),
                min: '',
                max: ''
            });
        });

        return legendArray;
    };

    factory.filterVuSite = function (data, url) {
        if (url == 'All') {
            return data;
        }
        var remainingData = [];
        data.forEach(function (vuEntry) {
            if (vuEntry.testSite.indexOf(url) != -1) {
                remainingData.push(vuEntry);
            }
        });
        return remainingData;
    };
    /**
     * processes the data to google's waypoint objects, then creates polylines with them.
     * The polyLines are automatically added and drawn on the map
     * @param map       google maps object
     * @param data      coverage data
     * @param colors
     * @param filter
     * @param valueFormatFunction
     */
    var createCoverageMap = function (map, data, colors, filter, valueFormatFunction) {
        var latLngArray = createLatLngArray(data);
        var polyLines = createPolyLines(latLngArray, map, colors, filter);
        return polyLines;
    };

    var createLatLngArray = function (data) {
        var latLngArray = [];
        data.forEach(function (entry) {
            var wp = new google.maps.LatLng(entry.latitude, entry.longitude);
            wp.value = entry.value;
            wp.timestamp = new Date(entry.timestamp);
            latLngArray.push(wp);
        });
        return latLngArray;
    };

    /**
     * Creates polylines from adjecend waypoints
     */

    var createPolyLines = function (waypoints, map, colors, filter) {
        var staticLegend = filter.staticLegend;
        var logscale = filter.logscale;
        var colorpicker = staticLegend ? getSemiRandomColorFromArray : (logscale ? getColorForLogaritmicValue : getColorForValue);

        var pathLines = [];
        var connectedWaypoints = [];
        waypoints.forEach(function (waypoint) {
                connectedWaypoints.push(waypoint);
                // the first waypoint creates a polyline with itself
                // the value of the polyline is the value of the current waypoint
                if (areCloseEnough(connectedWaypoints[0], waypoint)) {
                    var color = colorpicker(waypoint.value, filter.minimum, filter.maximum, colors);
                    var pathLine = createPolyline(connectedWaypoints, waypoint, color);
                    // filter set? > only add if the value is within the min & max boundaries
                    if (!filter.filter || (waypoint.value >= filter.minimum && waypoint.value <= filter.maximum)) {
                        pathLine.setMap(map);
                        pathLines.push(pathLine);
                    }

                    // prepare array for next iteration
                    connectedWaypoints = [];
                    connectedWaypoints.push(waypoint);
                } else {
                    connectedWaypoints = [];
                }
            }
        );
        return pathLines;
    };

    /**
     * This function returns a color for a value.
     * The exact color that the function returns, is determined by an array of colors, a minimum a maximum and the value itself.
     * First we clamp the value between the minimum and maxmimum value, so no odd sitiuations occur later on.
     * We then calculate an interval (delta), this is the amount of values that map onto a single color ( # of colors / # possible values between min and max).
     * The other way around: every color maps onto an interval. Eg. min: 0, max: 10, 2 colors. > [0,5[: red; [0,10]: blue
     * The function then calculates the index of the interval the value belongs to, which is the index of the color array
     *
     * @param value     The value for which the function returns a color
     * @param min       A minimum value
     * @param max       A maximum value
     * @param colors    An array of color objects (must have color property)
     * @returns a color
     */
    var getColorForValue = function (value, min, max, colors) {
        var colorVariations = colors.length;
        var originalValue = value;
        // clamp the value between min & max values
        value = value < min ? min : ((value > max) ? max : value);

        // edge cases
        if (originalValue == -1) {
            // -1 is the 'invalid value' value
            return "#757575"; //grey
        } else if (min == max && max == value) {
            // the min = max = value, that means only 1 possibility
            return colors[0].color;
        } else if (value == min) {
            // value is the minimum value
            return colors[0].color;
        } else if (value == max) {
            // value is the maximum
            return colors[colorVariations - 1].color
        }
        // formula
        // delta = (max - min) / #colorVariations
        // i = floor(value - min) / delta

        var delta = (max - min) / colorVariations;
        //delta = delta < 1 ? 1 : delta; // dont let the delta be smaller than 1, otherwise division by 0
        if (delta == 0) {
            return colors[0].color;
        }
        var index = Math.floor(((value - min) / delta));
        return colors[index].color;
    };

    var getColorForLogaritmicValue = function (value, min, max, colors) {
        value = value <= min ? (min + 0.01) : (value >= max) ? max - 1 : value;

        var getI = function (y, delta, min) {
            return Math.log10(y / min) / delta;
        };
        var getDelta = function (min, max, n) {
            return Math.log10(max / min) / n;
        };
        var delta = getDelta(min, max, colors.length);

        var index = Math.ceil(getI(value, delta, min)) - 1;
        if (index >= colors.length || index < 0) {
            console.error("Out of bounds, value:", value, "min:", min, "max:", max);
        } else {
            return colors[index].color;
        }
    };

    /**
     * Creates a polyline object
     * @param array     array of waypoints
     * @param wp
     * @param color     color of the polyline
     * @returns {google.maps.Polyline}
     */
    var createPolyline = function (array, wp, color) {
        var poly = new google.maps.Polyline({
            path: array,
            strokeColor: color,
            strokeOpacity: 0.95,
            strokeWeight: 10,
            zIndex: (wp.value == -1 ? google.maps.Marker.MAX_ZINDEX - 1 : google.maps.Marker.MAX_ZINDEX + 1)
        });
        // add additional informative fiels
        poly.value = wp.value;
        poly.timestamp = wp.timestamp;
        return poly;
    };

    /**
     * Returns true if 2 waypoints are close enought to eachother
     * @param waypoint1
     * @param waypoint2
     * @returns {boolean}
     */
    var areCloseEnough = function (waypoint1, waypoint2) {
        var longDiff = Math.abs(waypoint1.lng() - waypoint2.lng());
        var lattDiff = Math.abs(waypoint1.lat() - waypoint2.lat());
        return (longDiff < 0.005 && lattDiff < 0.005);
    };

    /**
     * Constructs and returns the string for the infowindow
     * @param label       the  displayname for the selected quality
     * @param formattedValue
     * @param timestamp
     * @param label   the discriminatorname for the selected quality
     * @returns {string}
     */
    factory.createContentString = function (formattedValue, timestamp, label) {
        return '<div class="scrollFix col-md-12 fullwidth">' +
            '<div class="row">' + '<b>Timestamp</b>: ' + $filter('tzdate')(timestamp, 'YYYY-MM-DD HH:mm:ss') + '</div>' +
            '<div class="row"><b>' + label + '</b>: ' + formattedValue + '</div>' +
            '</div>';
    };
    factory.createEmptyContentString = function (label) {
        return '<div class="scrollFix col-md-12 fullwidth">' +
            '<div class="row">' + '<b>Timestamp: </b>' + '' + '</div>' +
            '<div class="row">' + "No data" + '</div>' +
            '</div>';
    };
    /**
     * Returns a color per value (there are a number of fixed colors that will repeat)
     * @param value
     * @returns {*}
     */
    var getSemiRandomColorFromArray = function (value) {
        if (value == -1 || value == 0) {
            return "#757575"
        }
        if (typeof value == "boolean") {
            return value ? "#008000" : "#FF0000";
        }

        if (value == 8) {
            return '#00FF00';
        }

        var colors = graphUtil.getSemiRandomColorArray();
        if (value > colors.length) {
            return colors[value % colors.length];
        } else {
            return colors[value];
        }
    };

    /**
     * Finds and returns the minmum and maximum value in the data-array
     * @param data
     * @returns {{min: *, max: *}}
     */
    var findMinMaxInData = function (data) {
        var min = undefined;
        var max = undefined;
        data.forEach(function (entry) {
            if (entry.value == -1) return;
            var value = entry.value;
            if (isNaN(value)) {
                return;
            }
            if (!util.isDefined(min) || (value < min)) {
                min = value
            }
            if (!util.isDefined(max) || (value > max)) {
                max = value
            }
        });
        if (!util.isDefined(min)) {
            min = 0;
        }
        if (!util.isDefined(max)) {
            max = 0;
        }
        return {min: min, max: max};
    };

    /**
     * Returns a LatLngBounds object that represents a rectangle that contains all provided points
     * @param waypoints array of waypoint objects
     * @returns {google.maps.LatLngBounds}
     */
    var getOuterBounds = function (waypoints) {
        var minLat = undefined;
        var maxLat = undefined;
        var minLong = undefined;
        var maxLong = undefined;

        waypoints.forEach(function (wp) {
            if (!util.isDefined(minLong) || wp.lng() < minLong) {
                minLong = wp.lng();
            }
            if (!util.isDefined(maxLong) || wp.lng() > maxLong) {
                maxLong = wp.lng();
            }
            if (!util.isDefined(minLat) || wp.lat() < minLat) {
                minLat = wp.lat();
            }
            if (!util.isDefined(maxLat) || wp.lat() > maxLat) {
                maxLat = wp.lat();
            }
        });
        return new google.maps.LatLngBounds(
            new google.maps.LatLng(minLat, minLong),
            new google.maps.LatLng(maxLat, maxLong)
        );
    };
    return factory;
}];